import PropTypes from "prop-types";
import  React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { Typography } from "@mui/material";
import Button from "../toolkit/ButtonV1";
import TimesIcon from "../icons/TimesIcon";
import "../styles/SlidingPopup.css";

export default function SlidingPopup({
  className,
  title,
  children,
  anchor,
  open,
  closeSlidingPopup,
}) {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  function onOpen () {
    setIsOpen(true);
  }

  function onClose () {
    setIsOpen(false);
    closeSlidingPopup?.();
  }
  return (
    <SwipeableDrawer
      className={`sliding-popup ${className}`}
      anchor={anchor}
      open={isOpen}
      onClose={onClose}
      onOpen={onOpen}
    >
      <Box className="title-container">
        <Typography variant="h6">{title}</Typography>
        <Box sx={{ flexGrow: 1, display: "flex" }} />
        <Button
          leadingComponent={<TimesIcon />}
          role="linkGrey"
          size="small"
          onClick={onClose}
        />
      </Box>
      {children}
    </SwipeableDrawer>
  );
}

SlidingPopup.propTypes = {
  /**
   * Title
   */
  title: PropTypes.string,
  /**
   * Anchor: left or right side of page
   */
  anchor: PropTypes.string,
  /**
   * open - boolean to show or hide
   */
  open: PropTypes.bool,
};

SlidingPopup.defaultProps = {
  anchor: "right",
  open: false,
};
